import { useMemo } from "react";
import { List, RadioButton } from "react-native-paper";
import ItemList, { type ListItem } from "../ItemList";
import OnboardingLayout from "../OnboardingLayout";
import { LEVEL_OPTIONS } from "./constants";

type Props = {
	handleNext: () => void;
	selectedLevelId?: string;
	handleSelectLevel: (levelId: string) => void;
	cta?: string;
};
const ChooseLevelScreen = ({
	handleNext,
	selectedLevelId,
	handleSelectLevel,
	cta = "Continue",
}: Props) => {
	const items: ListItem[] = useMemo(
		() =>
			LEVEL_OPTIONS.map((level) => ({
				id: level.id,
				title: level.title,
				description: level.description,
				customLeft: (p) => (
					<List.Icon
						{...p}
						icon={() => (
							<RadioButton.Android
								value={level.id}
								status={selectedLevelId === level.id ? "checked" : "unchecked"}
								onPress={() => handleSelectLevel(level.id)}
							/>
						)}
					/>
				),
			})),
		[handleSelectLevel, selectedLevelId],
	);
	return (
		<OnboardingLayout
			onPrimaryPress={handleNext}
			disabled={!selectedLevelId}
			primaryActionLabel={cta}
		>
			<ItemList
				items={items}
				onSelect={handleSelectLevel}
				selectedId={selectedLevelId}
			/>
		</OnboardingLayout>
	);
};

export default ChooseLevelScreen;
